import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthSubscription {
  static apiResponse: ApiResponse

  // Server route: routes.ts:244 — GET /:apikey/subscriptions/me/snapshot
  public static async getSnapshot(
    api_key: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/me/snapshot`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:248 — PUT /:apikey/subscriptions/:id
  // Controller: put.subscription.controller.ts — body: { plan_id, billing_cycle }
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // NOTE: requires the subscription document _id, NOT "me"
  public static async changePlan(
    api_key: string,
    subscription_id: string,
    plan_id: string,
    billing_cycle: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, { plan_id, billing_cycle }, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts — POST /:apikey/subscriptions/:id/choose-plan
  // Controller: post.choose-plan.controller.ts — body: { plan_id, billing_cycle, addon_ids }
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // Used for first-time plan selection (plan_chosen === false)
  // Errors: 400 PLAN_DENIED, 409 PLAN_CHANGE_BLOCKED_BY_ADDONS
  public static async choosePlan(
    api_key: string,
    subscription_id: string,
    plan_id: string,
    billing_cycle: string,
    addon_ids: string[]
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/choose-plan`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, { plan_id, billing_cycle, addon_ids }, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:249 — POST /:apikey/subscriptions/:id/cancel
  // Controller: post.cancel.subscription.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // NOTE: requires the subscription document _id, NOT "me"
  public static async cancelSubscription(
    api_key: string,
    subscription_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/cancel`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:250 — POST /:apikey/subscriptions/:id/reactivate
  // Controller: post.reactivate.subscription.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // NOTE: requires the subscription document _id, NOT "me"
  public static async reactivateSubscription(
    api_key: string,
    subscription_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/reactivate`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:251 — POST /:apikey/subscriptions/:id/cancel-pending
  // Controller: post.cancel-pending.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // NOTE: requires the subscription document _id, NOT "me"
  public static async cancelPendingChange(
    api_key: string,
    subscription_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/cancel-pending`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:259 — GET /:apikey/subscriptions/:id/addons
  // Controller: get.subscription-addons.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // Response: { addons: [{ _id, subscription_id, addon_id: {populated}, status, activated_at, cancelled_at, cancel_at_period_end, current_period_start, current_period_end }] }
  public static async getSubscriptionAddons(
    api_key: string,
    subscription_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/addons`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:258 — POST /:apikey/subscriptions/:id/addons
  // Controller: post.activate-addon.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // Body: { addon_id: string } — just the addon's MongoDB ObjectId
  // Response (201): { _id, subscription_id, addon_id, status: 'active', activated_at, current_period_start, current_period_end, ... }
  // Errors: 404 ADDON_NOT_FOUND, 404 SUB_NOT_FOUND, 403 ADDON_INCOMPATIBLE, 409 ADDON_ALREADY_ACTIVE
  // Effect: IMMEDIATE activation + SNS event addon.activated → billing emits prorated invoice
  public static async activateAddon(
    api_key: string,
    subscription_id: string,
    addon_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/addons`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, { addon_id }, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:260 — DELETE /:apikey/subscriptions/:id/addons/:addonId
  // Controller: delete.subscription-addon.controller.ts
  // Guards: checkServiceApiKey, idUserJWT, ownsSubscription
  // Response (200): { message: "Add-on deactivated on subscription" }
  // Effect: NOT immediate — sets cancel_at_period_end=true, cancelled_at=now.
  //   Add-on stays active until current_period_end; background job then transitions to 'cancelled'.
  //   No refund — digital-commerce forbids negative lines and totals <= 0.
  // Error: 404 ADDON_NOT_ACTIVE
  public static async deactivateAddon(
    api_key: string,
    subscription_id: string,
    addon_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/subscriptions/${subscription_id}/addons/${addon_id}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }
}
